import { StickerType } from '@shopby/shop-sdk'
import { MouseEvent, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useNavigate } from 'react-router-dom'
import { styled } from 'styled-components'
import { formatNumberWithTruncation, onErrorImg, plusComma, setPrevList, setPrevPage } from '../../js/script'
import { RNPostMessage, AFWebLinkType } from '../../js/postMessage'
import LikeBtn from '../btn/LikeBtn'
import { useCommonContext } from '../provider/CommonProvider'
import { useAppContext } from '../provider/AppProvider'
import { IconStarOn } from '../svg/IconSvg'
import {
  BtnCart,
  DiscountedPrice,
  ProductBrandTitile,
  ProductItemWrap,
  ProductSalePrice,
  ProductTitle,
} from './ProductItem'

const imgURL = '/images'

type PropsType = {
  item: any
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
  setSelectProductNo: React.Dispatch<React.SetStateAction<string>>
  page?: number
  listItem?: any
  idx: number
  one?: any
  twoDepCategory?: any
  thirdDepLabel?: any
}

export default function ProductListItem({
  item,
  setIsModal,
  setSelectProductNo,
  idx,
  listItem,
  page,
  one,
  twoDepCategory,
  thirdDepLabel,
}: PropsType) {
  const [text, setText] = useState<StickerType[]>([])
  const [disCountAcc, setDisCountAcc] = useState<number>(0) // 적립금 1000단위로 끊기
  const navigate = useNavigate()
  const { isAppView } = useAppContext()
  const { hasAccessToken } = useCommonContext()

  const navigationHandler = (item: any) => {
    const baseUrl = process.env.REACT_APP_SHOP_URL
    const url = `aboutfishing://aboutfishing.com/?page=webview&url=${baseUrl}/product/${item?.productNo}`
    if (isAppView) {
      RNPostMessage(AFWebLinkType.moveToLink, { url })
    } else {
      navigate(`/product/${item?.productNo}`)
    }
  }

  useEffect(() => {
    setText([])
  }, [item])

  useEffect(() => {
    if (item) {
      const newImages: any[] = []
      const newTexts: any[] = []

      item.stickerInfos?.forEach((element: any) => {
        if (element.type === 'IMAGE') {
          newImages.push(element)
        } else {
          newTexts.push(element)
        }
      })
      setText(newTexts)
    }
  }, [item])

  useEffect(() => {
    if (item) {
      const count = formatNumberWithTruncation((item?.salePrice - item?.immediateDiscountAmt) * 0.1)
      setDisCountAcc(Number(count.replaceAll(',', '')))
    }
  }, [item])

  // useEffect(() => {
  //   setWish(item.liked);
  // }, [item]);

  return (
    // 상품내역 wrap

    <div className='product_item_wrap list'>
      {/* 상품이미지 영역 */}
      <div className='product_image_area'>
        <Link
          to={`/product/${item.productNo}`}
          onClick={(e: MouseEvent<HTMLAnchorElement>): void => {
            e.preventDefault()
            // TagManager.dataLayer(gtmClickItem);
            // setPrevScroll(document.documentElement.scrollTop);
            navigationHandler(item)
            setPrevList(listItem)
            setPrevPage(page)
          }}
        >
          {item.isSoldOut && (
            <div className='soldout'>
              <img src={`${imgURL}/img_soldout.png`} alt='' />
            </div>
          )}
          <div className='dim'></div>
          <img src={item.listImageUrls[0]} alt='' onError={onErrorImg} />
        </Link>
      </div>

      <div className='list_content_wrap'>
        <Link
          className='product_item'
          to={`/product/${item.productNo}`}
          onClick={(e: MouseEvent<HTMLAnchorElement>): void => {
            e.preventDefault()
            navigationHandler(item)
            // setPrevScroll(document.documentElement.scrollTop);
            setPrevList(listItem)
            setPrevPage(page)
          }}
        >
          {/* 브랜드명 */}
          {item.brandName && <div className='product_brand_title'>{item.brandName}</div>}

          {/* 상품명 */}
          <div className='product_title'>{item.productName}</div>

          {Math.floor((item?.immediateDiscountAmt / item?.salePrice) * 100) === 0 ? (
            <>
              <div className='discounted_price'>
                {/* 상품 할인 적용가 */}
                <p>{item.salePrice ? plusComma(item.salePrice - item.immediateDiscountAmt) : 0}원</p>
              </div>
            </>
          ) : (
            <>
              {/* 원 상품가 */}
              <div className='product_sale_price'>{plusComma(item.salePrice)}원</div>

              <div className='discounted_price'>
                <p className='percent'>{Math.floor((item.immediateDiscountAmt / item.salePrice) * 100)}%</p>

                {/* 상품 할인 적용가 */}
                <p>{item.salePrice ? plusComma(item.salePrice - item.immediateDiscountAmt) : 0}원</p>
              </div>
            </>
          )}

          {/* 최대혜택가 */}

          {item?.accumulationUseInfo?.usable &&
            item.enableCoupons &&
            (Number(
              item?.salePrice -
                item?.immediateDiscountAmt -
                item?.couponDiscountAmt -
                item?.accumulationInfo?.amount -
                (item?.accumulationInfo?.amount === 0 ? 0 : disCountAcc)
            ) === Number(item.salePrice - item.immediateDiscountAmt) ? null : (
              <div className='max_benefit'>
                <p className='badge'>회원혜택가</p>

                <>
                  <p>
                    {plusComma(
                      item?.salePrice -
                        item?.immediateDiscountAmt -
                        item?.couponDiscountAmt -
                        item?.accumulationInfo?.amount -
                        (item?.accumulationInfo?.amount === 0 ? 0 : disCountAcc) <
                        0
                        ? 0
                        : item?.salePrice -
                            item?.immediateDiscountAmt -
                            item?.couponDiscountAmt -
                            item?.accumulationInfo?.amount -
                            (item?.accumulationInfo?.amount === 0 ? 0 : disCountAcc)
                    )}
                    원
                  </p>
                </>
              </div>
            ))}

          {/* 페이백 적립금 5% + 추가적립금 */}
          {hasAccessToken &&
            (item?.accumulationInfo?.amount === 0 ? null : (
              <div className='save_mileage'>
                <p>
                  {`페이백 적립금 ${item?.accumulationInfo.rewardRateOfProduct}% `}
                  {plusComma(item?.accumulationInfo?.amount)}
                  <img src={`${imgURL}/icon_point.png`} alt='' />
                </p>
              </div>
            ))}

          {/* 별점 */}
          <div className='star_rating'>
            <IconStarOn width={isMobile ? 14 : 16} height={isMobile ? 14 : 16} />
            <span className='review_rating'>{item?.reviewRating}</span>
            <span className='review_num'>({item?.totalReviewCount})</span>

            {/* Npay */}
            <div className='npay'>
              <img src={`${imgURL}/icon_npay.png`} alt='Naver Pay' />
            </div>
          </div>

          {/* 당일배송, 오늘만 특가 */}
          {text && (
            <div className='item_txt_flag_detail'>
              {text.map((el: any, index: number) => {
                return (
                  <span className='delivery' key={index}>
                    {el.label}
                  </span>
                )
              })}
            </div>
          )}
        </Link>
      </div>
      <div className='button_area'>
        {item?.isSoldOut ? (
          <BtnCart
            className='btn_cart'
            onClick={(): void => {
              setIsModal(true)
              setSelectProductNo(item.productNo)
            }}
          >
            {/* <img src={`${imgURL}/icon_cart.png`} alt="" /> */}
            {!isMobile && `재입고 알림`}
          </BtnCart>
        ) : (
          <BtnCart
            className='btn_cart'
            onClick={(): void => {
              setIsModal(true)
              setSelectProductNo(item.productNo)
            }}
          >
            <img src={`${imgURL}/icon_cart.png`} alt='' /> {!isMobile && `장바구니`}
          </BtnCart>
        )}
        <LikeBtn
          item={item}
          text={'찜하기'}
          categoryDepth1={one}
          categoryDepth2={twoDepCategory}
          depthLabel={thirdDepLabel}
          idx={idx}
        ></LikeBtn>
      </div>
    </div>
  )
}
export const ProductListItemWrap = styled(ProductItemWrap)`
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--colGray3);
  &:last-child {
    border-bottom: none;
    margin-bottom: 48px;
  }
  @media screen and (min-width: 768px) {
    gap: 24px;
  }
`

export const ProductListImageArea = styled.div`
  width: 100px;
  min-width: 100px;
  height: 100px;
  min-height: 100px;
  @media screen and (min-width: 768px) {
    width: 200px;
    height: 200px;
    min-width: 200px;
    min-height: 200px;
  }
`

export const BtnListCart = styled(BtnCart)`
  width: 32px;
  height: 32px;
  margin-top: 8px;
  @media screen and (min-width: 768px) {
    width: 105px;
    height: 32px;
  }
`

export const ListContentWrap = styled.div`
  flex: 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 3px;
  min-width: 166.5px;
`

// 브랜드 제목
export const ProductListBrandTitile = styled(ProductBrandTitile)`
  margin-bottom: 2px;
  @media screen and (min-width: 768px) {
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    color: var(--colBlack);
    margin-bottom: 4px;
  }
`
// 상품 제목
export const ProductListTitile = styled(ProductTitle)`
  margin-bottom: 4px;
  font-size: 14px;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: var(--colBlack);
    margin-bottom: 8px;
  }
`
// 상품 원래 가격
export const ProductSaleListPrice = styled(ProductSalePrice)`
  margin-bottom: 2px;
  @media screen and (min-width: 768px) {
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    color: var(--colGray6);
  }
`
// 할인된 금액
export const DiscountedListPrice = styled(DiscountedPrice)`
  margin-bottom: 4px;
  @media screen and (min-width: 768px) {
    & p {
      font-size: 18px;
      font-weight: 600;
      line-height: 22px;
      color: var(--colBlack);
    }
    & p.percent {
      color: var(--colPointOrange);
    }
  }
`
